import React, { memo } from "react";
import { get } from "lodash";

const notRequiredText = 'No Equipment Necessary';

const getClassName = (isRequired,item) => {
    if (isRequired && item.title !== notRequiredText) {
        return 'hint-icon ion-asterisk addSpaceLeft required';
    }
    else if(item.title === notRequiredText)
    {
        return null;
    }
    return 'hint-icon ion-record addSpaceLeft';
}


const EquipmentItem = ({ item, type }) => {
    const imgURL = get(item, "images._1x1.url");
    const isRequired = type === 'required';
    const className = getClassName(isRequired,item);
    return (
        <div className={`flex-item space-between`} key={item.id}>
            <span className="item-image">
                {imgURL && <img src={imgURL} alt={item.title} />}
            </span>
            <span>
                {item.title}
                <i className={className}></i>
            </span>
        </div>)
}

export default memo(EquipmentItem);